import axios from 'axios'
import { buildApiBaseUrl, installAuthInterceptor, setAxiosAuthHeader } from '@/api/clientConfig'

const axiosApi = axios.create({
    baseURL: buildApiBaseUrl(process.env.VUE_APP_BASE_API), // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 30000, // request timeout
})
export const setAuthHeader = (token) => {
    setAxiosAuthHeader(axiosApi, token)
}

installAuthInterceptor(axiosApi, process.env.VUE_APP_BASE_API)

export default axiosApi;
